"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RailzAccountingServiceNames = void 0;
// https://docs.railz.ai/docs/supported-accounting-integrations
exports.RailzAccountingServiceNames = [
    'freshbooks',
    'dynamicsBusinessCentral',
    'oracleNetsuite',
    'quickbooksDesktop',
    'quickbooks',
    'sageBusinessCloud',
    'sageIntacct',
    'xero',
    'wave',
    'zohoBooks',
];
//# sourceMappingURL=Railz.js.map